// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwCheckbox from 'viewmodel/AwCheckboxViewModel';
import AwTextarea from 'viewmodel/AwTextareaViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
    import { ExistWhen,EnableWhen } from 'js/hocCollection';
const DivExistWhen = ExistWhen('div');
const AwButtonEnableWhen = EnableWhen(AwButton);
DivExistWhen.displayName = 'DivExistWhen';
AwButtonEnableWhen.displayName = 'AwButtonEnableWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/DesCatalogConsentPageService', () => import('js/DesCatalogConsentPageService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "data": {
        "acceptTnCCheckbox": {
            "displayName": "",
            "type": "BOOLEAN",
            "isRequired": "true",
            "isEditable": "true",
            "dbValue": false,
            "dispValue": "",
            "labelPosition": "PROPERTY_LABEL_AT_RIGHT"
        },
        "userConsentCheckbox": {
            "displayName": "",
            "type": "BOOLEAN",
            "isRequired": "false",
            "isEditable": "true",
            "dbValue": "",
            "dispValue": "",
            "labelPosition": "PROPERTY_LABEL_AT_RIGHT"
        },
        "commentOnCatalog": {
            "displayName": "{{i18n.commentTextInfo}}",
            "type": "STRING",
            "isRequired": "true",
            "isEditable": "true",
            "dbValue": "",
            "requiredText": "{{i18n.defaultStringforTextArea}}",
            "numberOfLines": 3,
            "maxLength": "2048"
        },
        "type": "Catalog",
        "_statusConstant": {
            "SUBMITTED": "Submitted",
            "UNPUBLISHED": "Unpublished",
            "PUBLISHED": "Published",
            "REJECTED": "Rejected"
        }
    },
    "props": {
        "accsessionid": {
            "type": "STRING"
        },
        "catalogspaceid": {
            "type": "STRING"
        },
        "setstatus": {
            "type": "STRING"
        },
        "catalogid": {
            "type": "STRING"
        },
        "isusersiemensadmin": {
            "type": "STRING"
        },
        "locale": {
            "type": "STRING"
        },
        "catalogname": {
            "type": "STRING"
        },
        "isapprovecommand": {
            "type": "STRING"
        }
    },
    "actions": {
        "validateCheckboxValue": {
            "actionType": "JSFunction",
            "method": "validateTnCCheckoxValue",
            "inputData": {
                "value": "{{data.acceptTnCCheckbox.dbValue}}"
            },
            "outputData": {
                "checked": "checked"
            },
            "events": {
                "success": []
            },
            "deps": "js/DesCatalogConsentPageService"
        },
        "performBatchJobOnAccept": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "validateCheckboxValue"
                },
                {
                    "action": "setStatusOfSelectedCatalog"
                }
            ]
        },
        "setStatusOfSelectedCatalog": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": false,
                    "data": {
                        "additionalProperties": {
                            "catalogspaceId": "{{props.catalogspaceid}}",
                            "isSiemensAdmin": "{{props.isusersiemensadmin}}",
                            "message": "{{data.commentOnCatalog.dbValue}}"
                        },
                        "appBaseUrl": "session",
                        "query": "mutation SetStatus( $setStatusInput: SetStatusInput) { setStatus( setStatusInput: $setStatusInput ) }",
                        "variables": {
                            "setStatusInput": {
                                "type": "{{data.type}}",
                                "status": "{{props.setstatus}}",
                                "id": "{{props.catalogid}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "output": "data.data.setStatus.output"
            },
            "events": {
                "success": [
                    {
                        "name": "setStausOfCatalog.success",
                        "eventData": {
                            "status": "{{data.output.status}}"
                        },
                        "condition": "output.success == true"
                    }
                ],
                "failure": [
                    {
                        "name": "setStausOfCatalog.failure",
                        "eventData": {
                            "status": "{{status}}"
                        },
                        "condition": "output.success == false"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "cancelAction": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "des-catalog-consent.cancel"
                    }
                ]
            }
        }
    },
    "onEvent": [
        {
            "eventId": "setStausOfCatalog.success",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "des-catalog-consent.success",
                "eventData": "{{eventData}}"
            }
        },
        {
            "eventId": "setStausOfCatalog.failure",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "des-catalog-consent.failure",
                "eventData": "{{eventData}}"
            }
        },
        {
            "eventId": "des-catalog-consent.cancel",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "des-catalog-consent.cancel",
                "eventData": "{{eventData}}"
            }
        }
    ],
    "conditions": {
        "enableButtonForSetStatus": {
            "expression": "data.acceptTnCCheckbox.dbValue && data.commentOnCatalog.dbValue.length >=10"
        },
        "showApproveButton": {
            "expression": "(props.setstatus === data._statusConstant.PUBLISHED || (props.setstatus === data._statusConstant.UNPUBLISHED && props.isapprovecommand === 'true')) && props.isusersiemensadmin === 'true' "
        },
        "showRejectButton": {
            "expression": "props.setstatus === data._statusConstant.REJECTED && props.isusersiemensadmin === 'true' "
        },
        "showSubmitButton": {
            "expression": "props.setstatus === data._statusConstant.SUBMITTED && props.isusersiemensadmin === 'false' "
        },
        "showUnpublishedButton": {
            "expression": "(props.setstatus === data._statusConstant.UNPUBLISHED && props.isusersiemensadmin === 'false') ||((props.setstatus === data._statusConstant.UNPUBLISHED && props.isapprovecommand === '') && props.isusersiemensadmin === 'true')"
        }
    },
    "lifecycleHooks": {
        "onMount": ""
    },
    "i18n": {
        "approve": [
            "DesCatalogConsentPageMessages"
        ],
        "reject": [
            "DesCatalogConsentPageMessages"
        ],
        "submit": [
            "DesCatalogConsentPageMessages"
        ],
        "unpublish": [
            "DesCatalogConsentPageMessages"
        ],
        "tncLabel1": [
            "DesCatalogConsentPageMessages"
        ],
        "ihaveReadTncCheckLbl": [
            "DesCatalogConsentPageMessages"
        ],
        "userConsentText1": [
            "DesCatalogConsentPageMessages"
        ],
        "userConsentText2": [
            "DesCatalogConsentPageMessages"
        ],
        "consentDeclaration": [
            "DesCatalogConsentPageMessages"
        ],
        "commentTextInfo": [
            "DesCatalogConsentPageMessages"
        ],
        "defaultStringforTextArea": [
            "DesCatalogConsentPageMessages"
        ],
        "acceptTheAcceptablePolicy": [
            "DesCatalogConsentPageMessages"
        ],
        "cancel": [
            "DesCatalogConsentPageMessages"
        ],
        "submitCatalogConsentText": [
            "DesCatalogConsentPageMessages"
        ],
        "consentText": [
            "DesCatalogConsentPageMessages"
        ],
        "submitTnc1": [
            "DesCatalogConsentPageMessages"
        ],
        "submitTnc2": [
            "DesCatalogConsentPageMessages"
        ],
        "submitTnc3": [
            "DesCatalogConsentPageMessages"
        ],
        "submitTnc4": [
            "DesCatalogConsentPageMessages"
        ],
        "submitTnc5": [
            "DesCatalogConsentPageMessages"
        ]
    },
    "_viewModelId": "DesCatalogConsentPage",
    "_uniqueViewModelId": "DesCatalogConsentPage",
    "ctx": {}
};

    /*
    <aw-panel class="h-12">
    <aw-panel-body>
        <aw-flex-column width="12">
            <div exist-when="conditions.showSubmitButton" style="margin-bottom: 20px;">
                <strong>You are Submitting "{{props.catalogname}}" for approval ?</strong><br><br>
                <pre style="white-space: pre-wrap;">
                     &nbsp;&nbsp;We (meaning the specific company that has provided or referred you to this privacy notice or that is identified on this page as being the operator of this website) believe that
                protecting the security and privacy of your personal data is important. This Privacy Notice explains how we collect, store, use, disclose and transfer (hereinafter “process”) your personal data.
                The personal data that we collect about you depends on the context of your interactions with us, the products,
                services and features that you use, your location, and applicable law.<br><br>
                   1. Processing of personal data related to your use of our websites, applications and online
                   Categories of personal data processed, and purpose of the processing </br>
                   When visiting our external and internal websites or using our applications, or online services (each an “Online Offering”), we may process the following categories of personal data:
                   Your contact information, such as full name, work address, work telephone number, work mobile phone number and work email address;
                   Organizational information, including job position and company name;
                   Information submitted as part of a support request, survey or comment or forum post;
                   Further personal data that you provide by filling in forms in our Online Offerings; and
                   Information on your interaction with the Online Offering, including your device and user identifier, information on your operating system, sites and services accessed during your visit, the date and time of each visitor request.
                   We process your personal data for the following purposes:
                   To provide the Online Offering’s services and functions which includes creating and administering your online account, updating, securing, and troubleshooting, providing support, as well as improving and developing our Online Offerings;
                   To bill your use of the Online Offering;
                   To verify your identity;
                   To answer and fulfill your requests or instructions;
                   To process your order or to provide you with access to specific information or offers;
                   To contact you with information and offers concerning our products and services, to send you further marketing information or to contact you in the context of customer satisfaction surveys as explained in Section 4; and
                   As reasonably necessary to enforce the Online Offering’s terms, to establish or preserve a legal claim or defense, to prevent fraud or other illegal activities, including attacks on our information technology systems.
                   Online Offerings provided by your organization
                   Our Online Offerings may be provided to you for your use by the organization to which you belong, such as our enterprise customers. If your organization provides you with access to an Online Offering, our processing of personal data provided by or collected from you or your organization in connection with the Online Offering’s content is performed under the direction of your organization and is subject to a data processing agreement between your organization and us. In such instance, your organization is responsible for any personal data contained in such content and you should direct any questions about how personal data contained in such content is used to your organization.<br><br>
                   2. Processing of personal data related to your use of our marketplaces
                   Categories of personal data processed, and purpose of the processing
                   When visiting our online stores and marketplaces (each a “Marketplace”), we may process the following categories of personal data:
                   Your contact information, such as full name, work address, work telephone number, work mobile phone number and work email address;
                   Organizational information, including job position and company name;
                   Payment data, such as data necessary for processing payments and fraud prevention, including credit/debit card numbers, security code numbers and other related billing information;
                   Information submitted as part of a support request, survey or comment or forum post;
                   Further personal data that you provide by filling in forms in our Marketplace;
                   Information that are legally required compliance screenings or export control checks; such as date of birth, nationality, place of residence, ID numbers, identity cards and information about relevant and significant litigation or other legal proceedings; and
                   Information on your interaction with the Marketplace, including your device and user identifier, information on your operating system, sites and services accessed during your visit, the date and time of each visitor request.h, exercise or defend legal claims.<br><br>
                   4. Processing of personal data for customer satisfaction surveys and for direct marketing
                   Where and as permitted under applicable law, we may process your contact information for direct marketing purposes (e.g. trade show invitations, newsletters with further information and offers concerning our products and services) and to carry out customer satisfactions surveys, in each case also by e-mail. You may object to the processing of your contact data for these purposes at any time by writing to contact@siemens.com or by using the opt-out mechanism provided in the respective communication you received.<br><br>
                   5. Processing of personal data related to your job application
                   When you apply for a job, we process your personal data as set out in the privacy notice of the Siemens Recruiting Portal or of the respective other recruiting platform you may use.<br><br>
                   6. Transfer and disclosure of personal data
                   We only transfer your personal data as described below:
                   Affiliated Companies and sales partners
                   For the purpose of and to the extent necessary to conduct our business relationship with you, we may share your personal data with affiliates and other third parties (e.g., sales partners and agents). We, for example, sell certain products and services only via local business relationships and in this case, we may transfer your personal data to our respective local affiliates or other sales partners conducting the business relationship with you.
                   Transactions on our Marketplaces
                   Via our Marketplaces we make available products, services and offerings of affiliates and other third parties. We share customers' personal data related to those transactions with that affiliate and/or third party.
                   Service Providers
                   We employ affiliates and other companies to perform functions on our behalf, such as IT-services or payment processing services. These affiliates and other companies process personal data only for the purpose of such services.
                   Other third parties
                   We may transfer personal data to other third parties in connection with complying with legal obligations or establishing, exercising or defending rights or claims (e.g., for court and arbitration proceedings, to regulators, law enforcement and government authorities, to attorneys and consultants).
                   The recipients of your personal data may be located outside of the country in which you reside.
                   Personal data published by you on Online Offerings (such as chat rooms or forums) may be globally accessible
                 </pre>
            </div>
            <div exist-when="conditions.showUnpublishedButton" style="margin-bottom: 20px;">
                <strong>Are you sure ? Do you want to unpublish the "{{props.catalogname}}" ?</strong><br><br>
                {{i18n.consentText}}
            </div>
            <div exist-when="conditions.showApproveButton" style="margin-bottom: 20px;">
                <strong>You are approving "{{props.catalogname}}" globally.</strong><br><br>
                {{i18n.consentText}}
            </div>
            <div exist-when="conditions.showRejectButton" style="margin-bottom: 20px;">
                <strong>Do you want to reject the "{{props.catalogname}}".</strong><br><br>
                {{i18n.consentText}}
            </div>
            <aw-flex-row height="5f" class="user-consent" style="margin-bottom: 20px;">
                <aw-flex-column width="1">
                    <aw-checkbox prop="data.acceptTnCCheckbox"></aw-checkbox>
                </aw-flex-column>
                <aw-flex-column width="11" wrap-style="wrap">
                    <div class="marketing-consent" style="display: flex;">
                        <div class=" mandatory-asterisk" style="color: red; margin-right: 4px;">
                            * </div>
                        <span>{{i18n.ihaveReadTncCheckLbl}}
                            <a href="https://www.sw.siemens.com/en-US/sw-terms/aup" target="_blank"
                                style="text-decoration: underline;" class="text-decoration-underline">
                                {{i18n.acceptTheAcceptablePolicy}}
                            </a>
                        </span>
                    </div>
                </aw-flex-column>
            </aw-flex-row>
            <aw-flex-row height="8f" class="user-consent">
                <div style="margin-top: 10px; width: 100%;">
                    <aw-textarea prop="data.commentOnCatalog"></aw-textarea>{{data.commentOnCatalog.displayName}}
                </div>
            </aw-flex-row>
        </aw-flex-column>
    </aw-panel-body>
    <aw-panel-footer>
        <aw-flex-column width="12">
            <aw-flex-row height="12" align-content="start">
                <aw-button button-type='base' size="auto" action="cancelAction">{{i18n.cancel}}</aw-button>
                <div exist-when="conditions.showApproveButton" class="marginForButtonOnConsentPage">
                    <aw-button size="auto" action="performBatchJobOnAccept"
                        enable-when="conditions.enableButtonForSetStatus">{{i18n.approve}}</aw-button>
                </div>
                <div exist-when="conditions.showRejectButton" class="marginForButtonOnConsentPage">
                    <aw-button size="auto" action="performBatchJobOnAccept"
                        enable-when="conditions.enableButtonForSetStatus">{{i18n.reject}}</aw-button>
                </div>
                <div exist-when="conditions.showSubmitButton" class="marginForButtonOnConsentPage">
                    <aw-button size="auto" action="performBatchJobOnAccept"
                        enable-when="conditions.enableButtonForSetStatus">{{i18n.submit}}</aw-button>
                </div>
                <div exist-when="conditions.showUnpublishedButton" class="marginForButtonOnConsentPage">
                    <aw-button size="auto" action="performBatchJobOnAccept"
                        enable-when="conditions.enableButtonForSetStatus">{{i18n.unpublish}}</aw-button>
                </div>
            </aw-flex-row>
        </aw-flex-column>
    </aw-panel-footer>
</aw-panel>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}  className="h-12">
        <AwPanelBody>
            <AwFlexColumn width="12">
                <DivExistWhen style={{marginBottom: '20px'}} existWhen={AwParseService.instance( "conditions.showSubmitButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                    <strong>
                        You are Submitting &quot;{AwParseService.instance( "props.catalogname" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}&quot; for approval ?
                    </strong>
                    <br>
                    </br>
                    <br>
                    </br>
                    <pre style={{whiteSpace: 'pre-wrap'}}>
                        We (meaning the specific company that has provided or referred you to this privacy notice or that is identified on this page as being the operator of this website) believe that
                protecting the security and privacy of your personal data is important. This Privacy Notice explains how we collect, store, use, disclose and transfer (hereinafter “process”) your personal data.
                The personal data that we collect about you depends on the context of your interactions with us, the products,
                services and features that you use, your location, and applicable law.
                        <br>
                        </br>
                        <br>
                        </br>
                        1. Processing of personal data related to your use of our websites, applications and online
                   Categories of personal data processed, and purpose of the processing
                        <br>
                        </br>
                        When visiting our external and internal websites or using our applications, or online services (each an “Online Offering”), we may process the following categories of personal data:
                   Your contact information, such as full name, work address, work telephone number, work mobile phone number and work email address;
                   Organizational information, including job position and company name;
                   Information submitted as part of a support request, survey or comment or forum post;
                   Further personal data that you provide by filling in forms in our Online Offerings; and
                   Information on your interaction with the Online Offering, including your device and user identifier, information on your operating system, sites and services accessed during your visit, the date and time of each visitor request.
                   We process your personal data for the following purposes:
                   To provide the Online Offering’s services and functions which includes creating and administering your online account, updating, securing, and troubleshooting, providing support, as well as improving and developing our Online Offerings;
                   To bill your use of the Online Offering;
                   To verify your identity;
                   To answer and fulfill your requests or instructions;
                   To process your order or to provide you with access to specific information or offers;
                   To contact you with information and offers concerning our products and services, to send you further marketing information or to contact you in the context of customer satisfaction surveys as explained in Section 4; and
                   As reasonably necessary to enforce the Online Offering’s terms, to establish or preserve a legal claim or defense, to prevent fraud or other illegal activities, including attacks on our information technology systems.
                   Online Offerings provided by your organization
                   Our Online Offerings may be provided to you for your use by the organization to which you belong, such as our enterprise customers. If your organization provides you with access to an Online Offering, our processing of personal data provided by or collected from you or your organization in connection with the Online Offering’s content is performed under the direction of your organization and is subject to a data processing agreement between your organization and us. In such instance, your organization is responsible for any personal data contained in such content and you should direct any questions about how personal data contained in such content is used to your organization.
                        <br>
                        </br>
                        <br>
                        </br>
                        2. Processing of personal data related to your use of our marketplaces
                   Categories of personal data processed, and purpose of the processing
                   When visiting our online stores and marketplaces (each a “Marketplace”), we may process the following categories of personal data:
                   Your contact information, such as full name, work address, work telephone number, work mobile phone number and work email address;
                   Organizational information, including job position and company name;
                   Payment data, such as data necessary for processing payments and fraud prevention, including credit/debit card numbers, security code numbers and other related billing information;
                   Information submitted as part of a support request, survey or comment or forum post;
                   Further personal data that you provide by filling in forms in our Marketplace;
                   Information that are legally required compliance screenings or export control checks; such as date of birth, nationality, place of residence, ID numbers, identity cards and information about relevant and significant litigation or other legal proceedings; and
                   Information on your interaction with the Marketplace, including your device and user identifier, information on your operating system, sites and services accessed during your visit, the date and time of each visitor request.h, exercise or defend legal claims.
                        <br>
                        </br>
                        <br>
                        </br>
                        4. Processing of personal data for customer satisfaction surveys and for direct marketing
                   Where and as permitted under applicable law, we may process your contact information for direct marketing purposes (e.g. trade show invitations, newsletters with further information and offers concerning our products and services) and to carry out customer satisfactions surveys, in each case also by e-mail. You may object to the processing of your contact data for these purposes at any time by writing to contact@siemens.com or by using the opt-out mechanism provided in the respective communication you received.
                        <br>
                        </br>
                        <br>
                        </br>
                        5. Processing of personal data related to your job application
                   When you apply for a job, we process your personal data as set out in the privacy notice of the Siemens Recruiting Portal or of the respective other recruiting platform you may use.
                        <br>
                        </br>
                        <br>
                        </br>
                        6. Transfer and disclosure of personal data
                   We only transfer your personal data as described below:
                   Affiliated Companies and sales partners
                   For the purpose of and to the extent necessary to conduct our business relationship with you, we may share your personal data with affiliates and other third parties (e.g., sales partners and agents). We, for example, sell certain products and services only via local business relationships and in this case, we may transfer your personal data to our respective local affiliates or other sales partners conducting the business relationship with you.
                   Transactions on our Marketplaces
                   Via our Marketplaces we make available products, services and offerings of affiliates and other third parties. We share customers&#39; personal data related to those transactions with that affiliate and/or third party.
                   Service Providers
                   We employ affiliates and other companies to perform functions on our behalf, such as IT-services or payment processing services. These affiliates and other companies process personal data only for the purpose of such services.
                   Other third parties
                   We may transfer personal data to other third parties in connection with complying with legal obligations or establishing, exercising or defending rights or claims (e.g., for court and arbitration proceedings, to regulators, law enforcement and government authorities, to attorneys and consultants).
                   The recipients of your personal data may be located outside of the country in which you reside.
                   Personal data published by you on Online Offerings (such as chat rooms or forums) may be globally accessible
                    </pre>
                </DivExistWhen>
                <DivExistWhen style={{marginBottom: '20px'}} existWhen={AwParseService.instance( "conditions.showUnpublishedButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                    <strong>
                        Are you sure ? Do you want to unpublish the &quot;{AwParseService.instance( "props.catalogname" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}&quot; ?
                    </strong>
                    <br>
                    </br>
                    <br>
                    </br>
                    {AwParseService.instance( "i18n.consentText" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                </DivExistWhen>
                <DivExistWhen style={{marginBottom: '20px'}} existWhen={AwParseService.instance( "conditions.showApproveButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                    <strong>
                        You are approving &quot;{AwParseService.instance( "props.catalogname" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}&quot; globally.
                    </strong>
                    <br>
                    </br>
                    <br>
                    </br>
                    {AwParseService.instance( "i18n.consentText" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                </DivExistWhen>
                <DivExistWhen style={{marginBottom: '20px'}} existWhen={AwParseService.instance( "conditions.showRejectButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                    <strong>
                        Do you want to reject the &quot;{AwParseService.instance( "props.catalogname" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}&quot;.
                    </strong>
                    <br>
                    </br>
                    <br>
                    </br>
                    {AwParseService.instance( "i18n.consentText" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                </DivExistWhen>
                <AwFlexRow height="5f" className="user-consent" style={{marginBottom: '20px'}}>
                    <AwFlexColumn width="1">
                        <AwCheckbox {...getField("data.acceptTnCCheckbox", fields, $index, null, null )}>
                        </AwCheckbox>
                    </AwFlexColumn>
                    <AwFlexColumn width="11" wrapStyle="wrap">
                        <div className="marketing-consent" style={{display: 'flex'}}>
                            <div className=" mandatory-asterisk" style={{color: 'red', marginRight: '4px'}}>
                                *
                            </div>
                            <span>
                                {AwParseService.instance( "i18n.ihaveReadTncCheckLbl" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                                <a href="https://www.sw.siemens.com/en-US/sw-terms/aup" target="_blank" style={{textDecoration: 'underline'}} className="text-decoration-underline">
                                    {AwParseService.instance( "i18n.acceptTheAcceptablePolicy" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                                </a>
                            </span>
                        </div>
                    </AwFlexColumn>
                </AwFlexRow>
                <AwFlexRow height="8f" className="user-consent">
                    <div style={{marginTop: '10px', width: '100%'}}>
                        <AwTextarea {...getField("data.commentOnCatalog", fields, $index, null, null )}>
                        </AwTextarea>
                        {AwParseService.instance( "data.commentOnCatalog.displayName" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                    </div>
                </AwFlexRow>
            </AwFlexColumn>
        </AwPanelBody>
        <AwPanelFooter>
            <AwFlexColumn width="12">
                <AwFlexRow height="12" alignContent="start">
                    <AwButton buttonType="base" size="auto" action={actions.cancelAction}>
                        {AwParseService.instance( "i18n.cancel" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                    </AwButton>
                    <DivExistWhen className="marginForButtonOnConsentPage" existWhen={AwParseService.instance( "conditions.showApproveButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                        <AwButtonEnableWhen size="auto" action={actions.performBatchJobOnAccept} enableWhen={AwParseService.instance( "conditions.enableButtonForSetStatus" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                            {AwParseService.instance( "i18n.approve" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                        </AwButtonEnableWhen>
                    </DivExistWhen>
                    <DivExistWhen className="marginForButtonOnConsentPage" existWhen={AwParseService.instance( "conditions.showRejectButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                        <AwButtonEnableWhen size="auto" action={actions.performBatchJobOnAccept} enableWhen={AwParseService.instance( "conditions.enableButtonForSetStatus" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                            {AwParseService.instance( "i18n.reject" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                        </AwButtonEnableWhen>
                    </DivExistWhen>
                    <DivExistWhen className="marginForButtonOnConsentPage" existWhen={AwParseService.instance( "conditions.showSubmitButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                        <AwButtonEnableWhen size="auto" action={actions.performBatchJobOnAccept} enableWhen={AwParseService.instance( "conditions.enableButtonForSetStatus" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                            {AwParseService.instance( "i18n.submit" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                        </AwButtonEnableWhen>
                    </DivExistWhen>
                    <DivExistWhen className="marginForButtonOnConsentPage" existWhen={AwParseService.instance( "conditions.showUnpublishedButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                        <AwButtonEnableWhen size="auto" action={actions.performBatchJobOnAccept} enableWhen={AwParseService.instance( "conditions.enableButtonForSetStatus" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                            {AwParseService.instance( "i18n.unpublish" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                        </AwButtonEnableWhen>
                    </DivExistWhen>
                </AwFlexRow>
            </AwFlexColumn>
        </AwPanelFooter>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;